function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.86879 0.868771C9.01639 0.715955 9.19294 0.594063 9.38815 0.510209C9.58335 0.426354 9.79331 0.382217 10.0058 0.38037C10.2182 0.378524 10.4289 0.419007 10.6255 0.499457C10.8222 0.579906 11.0008 0.698711 11.151 0.848939C11.3013 0.999167 11.4201 1.17781 11.5005 1.37444C11.581 1.57108 11.6214 1.78177 11.6196 1.99421C11.6177 2.20666 11.5736 2.41661 11.4898 2.61182C11.4059 2.80702 11.284 2.98358 11.1312 3.13117L10.4968 3.76557L8.23439 1.50317L8.86879 0.868771V0.868771ZM7.10319 2.63437L0.399994 9.33757V11.6H2.66239L9.36639 4.89677L7.10239 2.63437H7.10319Z",
  fill: "#9CA3AF"
});

function SvgPencilIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.732fc5b1.svg";
export { ForwardRef as ReactComponent };